<template lang="html">
  <div class="card-contact">
    <span class="figure">
      <svg
        width="2570"
        height="2851"
        viewBox="0 0 2570 2851"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2562.39 1042.29C2572.93 827.863 2578.17 595.05 2532.07 385.507C2492.72 206.732 2326.6 195.124 2192.55 162.357C2138.27 149.084 2083.81 135.81 2029.02 125.98C2009.09 122.37 1988.4 118.983 1968.94 127.646C1948.63 136.699 1947.44 173.076 1964.35 187.238C1978.71 199.29 1998.79 203.677 2015.56 208.176C2039.55 216.007 2062.7 227.447 2085.13 240.165C2136.29 269.211 2184.47 305.311 2223.91 354.017C2296.08 436.324 2340.81 533.459 2358.15 645.533C2375.49 757.552 2377.61 947.269 2369.16 1119.38C2362.83 1247.84 2327.64 1476.98 2272.89 1616.27C2218.15 1755.56 2139.6 1881.58 2037.19 1994.43C1934.79 2107.22 1808.95 2197.81 1659.74 2266.17C1510.52 2334.48 1339.39 2362.03 1146.3 2348.76C987.918 2337.87 836.672 2303.6 692.559 2245.96C548.446 2188.36 424.549 2085.06 320.822 1936.17C259.889 1846.92 214.874 1743.95 185.778 1627.21C98.677 1277.83 185.683 491.417 401.829 286.539C447.6 240.721 497.669 207.454 552.036 186.683C606.403 165.912 658.598 155.971 708.619 156.859C729.402 158.303 775.031 161.691 781.502 128.535C790.571 81.7169 735.732 76.4964 709.564 71.8313C595.209 44.3958 353.036 32.6218 238.35 7.07455C196.925 -2.14467 150.257 -14.8072 138.732 59.5575C129.663 117.983 120.405 178.13 105.432 238.999C44.9711 484.919 17.0554 742.502 4.53815 997.585C-13.7889 1370.46 19.0392 1838.2 183.652 2163.87C358.799 2510.37 651.796 2741.96 985.131 2819.16C1317.52 2896.19 1686.14 2836.15 1968.46 2605.9C2237.94 2386.13 2409.59 2042.13 2489.79 1672.14C2527.72 1497.31 2553.51 1222.4 2562.39 1042.29Z"
          fill="#33647E"
          fill-opacity="0.1"
        />
      </svg>
    </span>
    <h6 class="title" data-aos="fade-right" data-aos-duration="1050">
      Dejanos un mensaje
    </h6>
    <div class="row first">
      <div class="col-12 col-md-6 my-3 my-md-0">
        <Input
          data-aos="zoom-out"
          data-aos-duration="1000"
          placeholder="Nombre"
          :onChange="(value) => (name = value)"
          :value="name"
        />
      </div>
      <div class="col-12 col-md-6 my-3 my-md-0">
        <Input
          data-aos="zoom-out"
          data-aos-duration="1200"
          placeholder="Apellido"
          :onChange="(value) => (lastname = value)"
          :value="lastname"
        />
      </div>
    </div>
    <div class="row second">
      <div class="col-12">
        <Input
          data-aos="zoom-out"
          data-aos-duration="1400"
          placeholder="Email"
          :onChange="(value) => (email = value)"
          :value="email"
        />
      </div>
    </div>
    <div class="row third">
      <div class="col-12">
        <TextArea
          placeholder="Mensaje"
          data-aos="zoom-out"
          data-aos-duration="1600"
          :onChange="(value) => (message = value)"
          :value="message"
        />
      </div>
    </div>
    <div class="row check">
      <Checkbox
        id="aceptar"
        text="Acepto Términos y Condiciones"
        :onChange="(value) => (aceptar = value)"
        :value="aceptar"
      />
    </div>
    <div class="row">
      <Button 
        :clickBtn="this.onSend"
        :disabled = "(!this.name || !this.lastname || !this.email || !this.message) ? 'disabled' : false"
      > Enviar </Button>
    </div>
  </div>
  <ModalDocument
    :show="modalStatus"
    @updateShow="modalStatus = $event"
    :eventSuccess="this.successPopup"
    title="Información enviada con exito"
    description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vehicula euismod diam."
    coverImg="https://i.ibb.co/MhzbWmw/Footer-Doc.png"
    action="Ir a inicio"
  />
</template>
<script>
import Input from "../General/Input.vue";
import TextArea from "../General/TextArea.vue";
import Checkbox from "../General/Checkbox.vue";
import Button from "../General/Button.vue";

import ModalDocument from "../Document/ModalDocument.vue";
import { mapActions } from "vuex";
export default {
  components: {
    Input,
    TextArea,
    Checkbox,
    Button,
    ModalDocument,
  },
  data() {
    return {
      modalStatus: false,
      name: "",
      lastname: "",
      email: "",
      message: "",
      aceptar: false,
    };
  },
  methods: {
    ...mapActions(["addRow"]),
    openPopup() {
      this.modalStatus = true;
    },
    successPopup() {
      this.modalStatus = false;
    },
    onSend() {
      const _this = this;

      if (this.aceptar) {
        this.addRow({
          inputs: {
            name: this.name,
            lastname: this.lastname,
            email: this.email,
            message: this.message,
          },
          type: "POST",
          url: "sendContact",
        })
          .then((res) => {
            console.log(res);
            if (res.data.data === 'success') {
              this.openPopup();
              _this.name = "";
              _this.lastname = "";
              _this.email = "";
              _this.message = "";
              _this.aceptar = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.card-contact {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(51, 100, 126, 0.2);
  border-radius: 4px;
  padding: 110px 90px 120px;
  position: relative;
  overflow: hidden;
}
.card-contact .figure {
  position: absolute;
  bottom: -700px;
  right: -60px;
  z-index: 1;
}
.card-contact .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 28px;
  color: #013652;
  margin-bottom: 40px;
  position: relative;
  z-index: 2;
}
.row {
  position: relative;
  z-index: 2;
}
.row.first,
.row.second {
  margin-bottom: 20px;
}
.row.third {
  margin-bottom: 15px;
}
.row.check {
  margin-bottom: 30px;
}
@media (max-width: 576px) {
  .card-contact {
    padding: 40px;
  }
  .card-contact .title {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 16px;
  }
}
</style>
